import { Navigate } from 'react-router-dom';

import type { RotasDoModulo } from '@/app/rotas';

import { GoogleReturnPage } from './GoogleReturnPage';
import { PlatformBackupsPage } from './PlatformBackupsPage';
import { PlatformConfiguracoesPage } from './PlatformConfiguracoesPage';
import { PlatformLayout } from './PlatformLayout';
import { PlatformMaintenancePage } from './PlatformMaintenancePage';
import { PlatformTenantPage } from './PlatformTenantPage';
import { PlatformTenantsPage } from './PlatformTenantsPage';
import { PlatformTrailPage } from './PlatformTrailPage';

/** Rotas da administracao da plataforma. */
export const rotas: RotasDoModulo = {
  avulsas: [
    // A chegada da janela do Google fica fora da sessao: ela abre na janela que a tela
    // de backups abriu, e a sessao vive na memoria da aba de origem. Ela nao consulta
    // o servidor; avisa a aba de origem e se fecha.
    { path: '/admin/backups/retorno-google', element: <GoogleReturnPage /> },

    // A administracao da plataforma fica fora da moldura da empresa: o menu lateral e
    // o da empresa da sessao, e nada dele vale aqui. A sessao continua obrigatoria, e
    // quem decide o acesso e o servidor.
    {
      path: '/admin',
      element: <PlatformLayout />,
      exigeSessao: true,
      filhas: [
        { index: true, element: <Navigate to="empresas" replace /> },
        { path: 'empresas', element: <PlatformTenantsPage /> },
        { path: 'empresas/:tenantId', element: <PlatformTenantPage /> },
        { path: 'backups', element: <PlatformBackupsPage /> },
        { path: 'manutencao', element: <PlatformMaintenancePage /> },
        { path: 'trilha', element: <PlatformTrailPage /> },
        // Configuracoes da instalacao (ADR 0096): por enquanto, o E-mail.
        { path: 'configuracoes', element: <Navigate to="email" replace /> },
        {
          path: 'configuracoes/email',
          element: <PlatformConfiguracoesPage secao="email" />,
        },
      ],
    },
  ],
};
